import { el, clear } from '../../utils/dom.js';
import { Maintenance, Items, ItemUnits } from '../../api/resources.js';
import { field, readForm } from '../../components/form.js';
import { ok, err } from '../../components/toast.js';
import { navigate } from '../../router/index.js';

const TYPES = [
  { value: 'preventivo', label: 'Preventivo' },
  { value: 'correctivo', label: 'Correctivo' },
  { value: 'limpieza',   label: 'Limpieza' },
  { value: 'revision',   label: 'Revision' },
  { value: 'reparacion', label: 'Reparacion' },
  { value: 'calibracion',label: 'Calibracion' },
  { value: 'cambio_pieza', label: 'Cambio de pieza' },
];

export default async function MaintenanceFormPage(outlet) {
  clear(outlet);
  let units = [], bulkItems = [];
  try {
    [units, bulkItems] = await Promise.all([
      ItemUnits.list({ limit: 1000 }).then((r) => r.data || []),
      Items.list({ limit: 500, kind: 'bulk' }).then((r) => r.data || []),
    ]);
  } catch (ex) { outlet.innerHTML = `<div class="empty">Error: ${ex.message}</div>`; return; }

  outlet.appendChild(el('div', { class: 'page-head' },
    el('h1', {}, 'Nuevo mantenimiento'),
    el('a', { href: '#/maintenance', class: 'btn ghost' }, '← Volver'),
  ));

  const form = el('form', {
    onsubmit: async (e) => {
      e.preventDefault();
      const d = readForm(form);
      if (!d.item_unit_id && !d.item_id) { err('Selecciona un equipo (unidad o item bulk)'); return; }
      try {
        const created = await Maintenance.create({
          item_unit_id: d.item_unit_id || undefined,
          item_id:      d.item_unit_id ? undefined : (d.item_id || undefined),
          type: d.type,
          description: d.description || undefined,
          start_date: d.start_date ? new Date(d.start_date).toISOString() : undefined,
          end_date:   d.end_date   ? new Date(d.end_date).toISOString()   : undefined,
          technician: d.technician || undefined,
          cost: d.cost ? Number(d.cost) : 0,
          next_maintenance_date: d.next_maintenance_date || undefined,
          notes: d.notes || undefined,
        });
        ok(`Mantenimiento ${created.code} creado`);
        navigate(`/maintenance/${created.id}`);
      } catch (ex) { err(ex.message); }
    },
  });

  const card = el('div', { class: 'card mb-4' });
  const grid = el('div', { class: 'form-grid' });
  grid.append(
    field({ name: 'item_unit_id', label: 'Unidad serializada', type: 'select',
      options: units.map((u) => ({ value: u.id, label: `${u.item_name} — ${u.serial_number || u.internal_code || u.id}` })) }),
    field({ name: 'item_id', label: 'Item bulk (alternativa)', type: 'select',
      options: bulkItems.map((i) => ({ value: i.id, label: i.name })) }),
    field({ name: 'type', label: 'Tipo', type: 'select', required: true, options: TYPES }),
    field({ name: 'technician', label: 'Tecnico responsable' }),
    field({ name: 'start_date', label: 'Fecha inicio', type: 'datetime-local' }),
    field({ name: 'end_date',   label: 'Fecha fin',    type: 'datetime-local' }),
    field({ name: 'cost', label: 'Costo', type: 'number', step: '0.01' }),
    field({ name: 'next_maintenance_date', label: 'Proximo mantenimiento', type: 'date' }),
    field({ name: 'description', label: 'Descripcion', type: 'textarea', full: true }),
    field({ name: 'notes',       label: 'Notas',       type: 'textarea', full: true }),
  );
  card.appendChild(grid);
  form.appendChild(card);

  form.appendChild(el('div', { class: 'flex gap-2 justify-between' },
    el('a', { href: '#/maintenance', class: 'btn' }, 'Cancelar'),
    el('button', { class: 'btn primary', type: 'submit' }, 'Crear'),
  ));
  outlet.appendChild(form);
}
